import { useEffect, useState } from 'react'

import DraftItemsList from './DraftItemsList/DraftItemsList'
import Footer from './Footer/Footer'
import Header from './Header/Header'
import useDraftItemsDecisions from './hooks/useDraftItemsDecisions'
import * as Styles from './styles'

const ReviewRecommendationsStep = ({ draftItems, progressItems, showHts, onConfirm, confirmingDraftItems, onStop }) => {
  const isPending = progressItems?.total > 0 && progressItems?.completed < progressItems?.total
  const isFinished = progressItems?.total > 0 && progressItems?.completed === progressItems?.total
  const progressBarPercentage = isPending ? (progressItems.completed / progressItems.total) * 100 : isFinished ? 100 : 0
  const [hideProgressBar, setHideProgressBar] = useState(false)

  const {
    getHsDecision,
    getHtsDecision,
    acceptHs,
    discardHs,
    undoHs,
    acceptHts,
    discardHts,
    undoHts,
    restoreHs,
    restoreHts,
    isAllManaged,
    acceptedCount,
    getAcceptedItems,
  } = useDraftItemsDecisions({ draftItems, showHts })

  useEffect(() => {
    if (isFinished) {
      const timer = setTimeout(() => {
        setHideProgressBar(true)
      }, 500)

      return () => clearTimeout(timer)
    }
  }, [isFinished])

  return (
    <Styles.Container>
      <Header hideProgressBar={hideProgressBar} progressBarPercentage={progressBarPercentage} onStop={onStop} />
      <DraftItemsList
        draftItems={draftItems}
        showHts={showHts}
        getHsDecision={getHsDecision}
        getHtsDecision={getHtsDecision}
        onHsAccept={acceptHs}
        onHsDiscard={discardHs}
        onHsUndo={undoHs}
        onRestoreHs={restoreHs}
        onHtsAccept={acceptHts}
        onHtsDiscard={discardHts}
        onHtsUndo={undoHts}
        onRestoreHts={restoreHts}
      />
      <Footer
        acceptedCount={acceptedCount}
        onConfirm={() => onConfirm(getAcceptedItems())}
        disabled={confirmingDraftItems || !isAllManaged}
        loading={confirmingDraftItems}
      />
    </Styles.Container>
  )
}

export default ReviewRecommendationsStep
